// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VueAxios from './services/VueAxios';
import Keycloak from './services/KeycloakService';
import Vuelidate from 'vuelidate';

Vue.use(Vuelidate);

Vue.config.productionTip = false;

const baseUrl = process.env.ROCKSTARS_BONUS_BASE_URL;

Vue.use(VueAxios, {
    baseUrl: `${baseUrl}/api`
});

Vue.use(Keycloak, {
    keycloakOptions: {
        realm: 'rockstars',
        url: `${baseUrl}/auth`,
        'public-client': true,
        clientId: 'my-bonus-webapp'
    },
    keycloakInitOptions: {
        onLoad: 'login-required',
        checkLoginIframe: false
    },
    tokenOptions: {
        validity: 1500000,
        minValidity: 30000
    }
});

Vue.prototype.$isDevUrl = () => {
    const allowedUrls = ['localhost', 'rockstars-bonus-dev.isaac.local'];
    return allowedUrls.includes(window.location.hostname);
};

Vue.prototype.$keycloak.init().then((response) => {
    /* eslint-disable no-new */
    new Vue({
        el: '#app',
        router,
        components: { App },
        template: '<App/>'
    });
});
